<div class="tw-p-6 tw-min-w-[320px]">
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-8 tw-mb-4">
    <h2 class="tw-text-lg tw-font-semibold tw-my-0 tw-text-gray-800 dark:tw-text-gray-100">
      Chat Settings
    </h2>
    <button mat-icon-button mat-dialog-close aria-label="Close settings">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
    <div>
      <div class="tw-text-sm tw-font-medium tw-text-gray-800 dark:tw-text-gray-200">
        LangGraph instance
      </div>
      <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
        Which backend instance chat queries run against
      </div>
    </div>
    <app-langgraph-instance-selector></app-langgraph-instance-selector>
  </div>
</div>
